import React, { Fragment, useState } from 'react';

import { ArrowsClockwiseIcon, LockIcon, TrashIcon } from '@phosphor-icons/react';
import { Link, useParams } from 'react-router-dom';
import DocumentPopupRemove from '../DocumentPopupRemove';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reloadDocument } from 'api/documents';

export default function DocumentListItem({
    document
}) {

    const { folderId } = useParams();

    const cache = useQueryClient();

    const [ removePopup, setRemovePopup ] = useState(false);

    const { mutate } = useMutation({
        mutationKey: ['reloadDocument'],
        mutationFn: reloadDocument,
        onSuccess: () => {
            cache.invalidateQueries(['documents', folderId, document._id]);
        },
        onError: (error) => {
            console.error("Error updating document-tag:", error);
        }
    });

    const removePopupHandler = (e) => {
        e.preventDefault();
        setRemovePopup(true);
    }

    const reloadHandler = (e) => {
        e.preventDefault();
        return mutate({ id: document._id });
    }

    return (
        <Fragment>
            <Link to={`/settings/documents/${document.folder?._id}/${document._id}`} className='border-b last:border-0 border-light hover:bg-verylight flex items-center gap-4 p-4'>
                <div className='flex-4'>
                    <p className='font-semibold'>{document.name}</p>
                    <p className='text-sm text-muted'>{document.path}</p>
                </div>
                <div className='flex-2'>
                    <p className='text-sm text-muted'>{document.chunks?.count} chunks</p>
                </div>
                <div className='flex-1 flex items-center justify-end gap-4'>
                    {(document.chunks?.sensitive > document.chunks?.insensitive) &&
                        <div className=''>
                            <LockIcon size={20} className='inline-block mb-1' />
                        </div>
                    }
                    <div className='' onClick={reloadHandler}>
                        <ArrowsClockwiseIcon size={20} className='inline-block mb-1' />
                    </div>
                    <div className='' onClick={removePopupHandler}>
                        <TrashIcon size={20} className='inline-block mb-1' />
                    </div>
                </div>
            </Link>
            <DocumentPopupRemove
                visible={removePopup}
                setVisible={setRemovePopup}
                document={document}
            />
        </Fragment>
    )
}
